module.exports = __webpack_public_path__ + "static/media/bluePoppedBalloon.1c7a143a.svg";